// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningRequestSearchBase } from './financialScreeningRequestSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningRequestSearchResponse {
    'requests': Array<FinancialScreeningRequestSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningRequestSearchResponse>> = [
        {
            "name":     "requests",
            "baseName": "requests",
            "type":     "Array<FinancialScreeningRequestSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningRequestSearchResponse.attributeTypeMap;
    }
}
